module.exports = __webpack_public_path__ + "img/agency-service-01.a40382b4.jpg";